import { TonClient } from "ton";
import { getHttpEndpoint } from "@orbs-network/ton-access";
import { getNetwork } from "./hooks/useNetwork";

// Function to get endpoint with error handling
async function getEndpointSafely(): Promise<string> {
  try {
    // Try to get the endpoint dynamically based on URL parameters
    const network = getNetwork(new URLSearchParams(window.location.search));

    console.log("Attempting to get TON endpoint for network:", network);

    const endpoint = await getHttpEndpoint({
      network: network as "mainnet" | "testnet",
    });

    console.log("Successfully got TON endpoint:", endpoint);
    return endpoint;
  } catch (error) {
    console.error("Failed to get TON endpoint from ton-access:", error);

    // Fallback to direct endpoints based on network
    const network = getNetwork(new URLSearchParams(window.location.search));

    if (network === "testnet") {
      console.log("Using fallback testnet endpoint");
      return "https://testnet.toncenter.com/api/v2/jsonRPC";
    } else {
      console.log("Using fallback mainnet endpoint");
      return "https://toncenter.com/api/v2/jsonRPC";
    }
  }
}

// Initialize endpoint - use a function instead of top-level await
let endpointPromise: Promise<string> | null = null;

function getEndpointPromise(): Promise<string> {
  if (!endpointPromise) {
    endpointPromise = getEndpointSafely();
  }
  return endpointPromise;
}

export async function getClient(): Promise<TonClient> {
  const endpoint = await getEndpointPromise();
  return new TonClient({ endpoint });
}

export async function getEndpoint(): Promise<string> {
  return getEndpointPromise();
}
